<template>
	<div class="page">
		<!-- your page -->
		<div class="title">
			<div class="titleBox">
				<img src="../assets/index/hot.png" alt="">
			</div>
		</div>
		<div class="brand">
			<div class="brandItem" v-for="item in brand" :data-id="item.id" :data-name="item.name" @click="goType">
				<img :src="item.logo" alt="" :data-id="item.id">
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'hot',
		data(){
			return {
				brand:[]
			}
		},
		methods:{
			fetchData(){
				var data = {
					method:"hotSupply.positionList"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.brand = res.data
					}else{
						that.globalTest("hotSupply.positionList","error",res.msg,res.data)
					}
				})
			},
			goType(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/type',query:{brand:id,type:'brand'}})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.title{
		width: 100%;
		height: 80px;
	}
	.title .titleBox{
		width: 170px;
		height: 100%;
		float: left;
	}
	.title .titleBox img{
		display: block;
		margin-top: 23px;
	}
	.brand{
		width: 100%;
		height: 392px;
		background: #FFFFFF;
		box-shadow: 3px 3px 3px #E3E3E3;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
	}
	.brand .brandItem{
		width: 250px;
		height: 165px;
		float: left;
		margin-top: 20px;
		margin-left: 39.6px;
		cursor: pointer;
	}
	.brand .brandItem img{
		width: 200px;
		height: 85px;
		display: block;
		margin: 40px auto;
	}
	.brand .brandItem:hover img{
		animation: big 0.3s 1;
		animation-fill-mode: forwards;
	}
	@keyframes big{
		from{}
		to{
			transform: scale(1.1,1.1);
		}
	}
</style>
